<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close :loading="modal_loading">
			<template #default>
				<div >
					<el-divider content-position="left">原单</el-divider>
					<vxe-table align="center" size="mini" :data="olddata" border style="margin-bottom: 50px;">
						<vxe-column field="spec_code" title="产品编码"></vxe-column>
						<vxe-column field="goods_name" title="产品名称"></vxe-column>
						<vxe-column field="specName" title="规格"></vxe-column>
						<vxe-column field="tp_item_size" title="订单数量"></vxe-column>
						<vxe-column field="storage_name" title="仓库"></vxe-column>
						<!-- 						<vxe-column field="pivt_quantity" title="实际库存"></vxe-column>
						<vxe-column field="pivt_lock" title="锁定"></vxe-column> -->
						<vxe-column field="available" title="可用" width="60">
							<template #default="{row}">
								<span>{{row.pivt_quantity - row.pivt_lock}}</span>
							</template>
						</vxe-column>
						<vxe-column field="purchase_billCode" title="最近采购单">
							<template #default="{row}">
								<span v-if="row.purchase">{{row.purchase.billCode}}</span>
							</template>
						</vxe-column>
						<vxe-column field="purchase_remark" title="采购类型">
							<template #default="{row}">
								<span v-if="row.purchase">{{row.purchase.remark}}</span>
							</template>
						</vxe-column>
						<vxe-column field="purchase_size" title="采购数量">
							<template #default="{row}">
								<span v-if="row.purchase">{{row.purchase.size}}</span>
							</template>
						</vxe-column>
						<vxe-column field="purchase_size" title="预计到货日期">
							<template #default="{row}">
								<span v-if="row.purchase">{{row.purchase.planArriveDate}}</span>
							</template>
						</vxe-column>
						<vxe-column title="操作" width="65">
							<template #default="{row}">
								<el-button size="mini" type="text" @click="splitorder(row)">拆单</el-button>
							</template>
						</vxe-column>
					</vxe-table>
					<el-divider content-position="left">拆分</el-divider>
					<vxe-table ref="splitdatatable" align="center" size="mini" :data="splitdata" border
						style="margin-bottom: 50px;">
						<vxe-column field="spec_code" title="产品编码"></vxe-column>
						<vxe-column field="goods_name" title="产品名称"></vxe-column>
						<vxe-column field="specName" title="规格"></vxe-column>
						<vxe-column field="tp_item_size" title="拆出数量"></vxe-column>
						<vxe-column field="storage_name" title="目标仓库"></vxe-column>
						<!-- 						<vxe-column field="available" title="可用">
							<template #default="{row}">
								<span>{{row.pivt_quantity - row.pivt_lock}}</span>
							</template>
						</vxe-column> -->
						<vxe-column title="操作" width="65">
							<template #default="{row}">
								<el-button size="mini" type="text" @click="deleteorder(row)"
									style="color: #F56C6C;">删除</el-button>
							</template>
						</vxe-column>
					</vxe-table>
				</div>
			</template>
			<template #footer>
				<vxe-button status="primary" content="提交" @click="submit"></vxe-button>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>

		<splitoption-index :data="currentrow" ref="splitoptionIndex" @submit="splitSubmit" />

	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import splitoptionIndex from './splitoption/index.vue'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			detail: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model: false,
				modal_title: '订单明细',
				modal_width: 1200,
				modal_height: 800,
				sourceolddata: [],
				olddata: [],
				splitdata: [],
				currentrow: null,
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				this.sourceolddata = JSON.parse(JSON.stringify(this.detail))
				this.olddata = JSON.parse(JSON.stringify(this.detail))
				this.splitdata = []
			},
			submit() {
				if (this.splitdata.length == 0) {
					this.$message.error('拆分数据不能为空')
					return
				}
				this.modal_loading = true
				let data = this.splitdata.map((item) => {
					return {
						tp_off_id: item.tp_off_id,
						bar_code: item.bar_code,
						spec_code: item.spec_code,
						sys_trade: item.sys_trade,
						sys_sku_id: item.sys_sku_id,
						salercpt_no: item.salercpt_no,
						tp_tid: item.tp_tid,
						storage_uid: item.storage_uid,
						sys_item_id: item.sys_item_id,
						storage_name: item.storage_name,
						tp_item_size: item.tp_item_size
					}
				})
				this.$api.preoutorder.submitsplitorder({
					tp_tid:data[0].tp_tid,
					salercpt_no:data[0].salercpt_no,
					order: data
				}).then(() => {
					this.modal_loading = false
					this.modal_cancel()
					this.$message.success('操作成功')
				},()=>{
					this.modal_loading = false
				})

				//this.init()
			},
			reset() {
				//this.init()
			},
			splitorder(row) {
				this.currentrow = row
				this.$refs.splitoptionIndex.modal_show()
				//console.log(row)
			},
			deleteorder(row) {
				this.splitdata = this.splitdata.filter((item) => {
					return item._X_ROW_KEY != row._X_ROW_KEY
				})
				this.checkOrderdata()

			},
			splitSubmit(e) {
				let splitobj = JSON.parse(JSON.stringify(e.data))
				splitobj.tp_item_size = e.config.splitnum
				splitobj.storage_name = e.config.warehouse.storage_name
				splitobj.storage_uid = e.config.warehouse.storageID
				let exist = this.splitdata.find((item) => {
					return item.tp_off_id == splitobj.tp_off_id && item.storage_uid == splitobj.storage_uid
				})
				if (exist) {
					exist.tp_item_size += e.config.splitnum
				} else {
					this.splitdata.push(splitobj)
				}

				this.checkOrderdata()
				console.log(e)
			},

			checkOrderdata() {
				let sourceolddata = JSON.parse(JSON.stringify(this.sourceolddata))
				sourceolddata.forEach((item) => {
					this.splitdata.forEach((_item) => {
						if (item.tp_off_id == _item.tp_off_id) {
							item.tp_item_size = item.tp_item_size - _item.tp_item_size
							item.pivt_lock = item.pivt_lock - _item.tp_item_size
						}
					})
				})
				this.olddata = sourceolddata.filter((item) => {
					return item.tp_item_size > 0
				})
				
			}
		},
		components: {
			splitoptionIndex
		}
	}
</script>